<template>
  <div class="strage_wrapper">
    <back-header v-show="hideHeader" :head-title="title"></back-header>
    <div class="content_wrapper">
      <div class="strage_content">
        <div class="title">{{detailInfo.title}}</div>
        <div class="strage_detail" v-html="detailInfo.description"></div>
      </div>
      <div class="strage_bottom">
        <ul>
          <li @click="goTrade(detailInfo.productCode)">{{detailInfo.productName}}</li>
          <li
            :class="[{'red':detailInfo.pro == 'red'},{'green':detailInfo.pro == 'green'}]"
          >{{detailInfo.tendency | filterTrend}}</li>
        </ul>
      </div>
      <div class="strage_info">风险提示：市场策略仅供参考</div>
    </div>
    <div class="trade_btn" @click="goTrade(detailInfo.productCode)">去交易</div>
    <div class="analyst_part">
      <div class="analyst_info">
        <img src="~assets/images/analyst.png" alt @click="goDetail(detailInfo.analystId)" />
        <div class="name">{{detailInfo.analystName}}</div>
        <div class="time">
          <span>{{detailInfo.publishDate}}</span> 发布
        </div>
      </div>
      <div class="analyst_guide">
        <div class="guide_title">基本分析面</div>
        <div class="guide_content" v-html="detailInfo.content"></div>
      </div>
      <div class="like">
        <div class="like_detail" @click="handleClick(detailInfo.id)">
          <img ref="imgs" src="~assets/images/like01.png" alt />
        </div>
        <span :ref="detailInfo.id">{{detailInfo.totalLikes}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getStore, setStore, removeStore } from "assets/commonjs/storage";
import backHeader from "components/header/backHeader";

import { toast } from "assets/commonjs/toast";
import user from "assets/commonjs/userInfo";
export default {
  data() {
    return {
      detailInfo: [],
      title: "策略详情",
      companyId: 1,
      id: "",
      tradeUrl: process.env.VUE_APP_H5_TRADE,
      pc: false,
      like01: require("../../assets/images/like01.png"),
      like02: require("../../assets/images/like02.png"),
      hideHeader: false
    };
  },
  components: { backHeader },
  mounted() {
    this.id = this.$route.params.id.slice(1);
    removeStore("id_" + this.id);
    if (this.id) {
      this.getStrageData(this.id);
    }
    if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.pc = true;
    }
  },
  created() {
    if (getStore("indexLiveHeader")) {
      this.hideHeader = false;
    } else {
      this.hideHeader = true;
    }
  },
  filters: {
    filterTrend(val) {
      if (val == 0) {
        return "看多";
      } else if (val == 1) {
        return "看空";
      }
    }
  },
  methods: {
    getStrageData(id) {
      let data = {
        id: id,
        companyId: this.companyId
      };
      this.$api.strageList.getStrageDataById(data).then(res => {
        if (res.data && res.data.code == 0) {
          let data = res.data.result;
          let ampClass;
          if (getStore("patternLabel") == "redGreen" || getStore('patternLabel') == undefined) {
            if (data.tendency == 0) {
              ampClass = "red";
            } else {
              ampClass = "green";
            }
          } else {
            if (data.tendency == 0) {
              ampClass = "green";
            } else {
              ampClass = "red";
            }
          }
          this.$set(data, "pro", ampClass);
          this.detailInfo = data;
        }
      });
    },
    goDetail(id) {
      this.$router.push(`/analystDetail/:${id}`);
    },
    goTrade(symbol) {
      user.goTrade(symbol);
    },
    handleClick(id) {
      let clickedId = getStore("id_" + id);
      let status;
      if (clickedId == id) {
        //表示点击过
        status = 1;
        this.count = -1;
      } else {
        //未点击过
        status = 0;
        this.count = 1;
      }
      let data = {
        id: id,
        count: this.count,
        companyId: this.companyId
      };
      this.$api.strageList.addLike(data).then(res => {
        if (res.data && res.data.code == 0) {
          this.likeSucc(status, id);
        } else {
          toast(res.data.message);
        }
      });
    },
    likeSucc(status, id) {
      let activeEle = this.$refs[id];
      let activeImg = this.$refs.imgs;
      if (status == 0) {
        activeEle.innerHTML = Number(activeEle.innerHTML) + 1;
        setStore("id_" + id, id);
        activeImg.src = this.like02;
      } else if (status == 1) {
        activeEle.innerHTML = Number(activeEle.innerHTML) - 1;
        activeImg.src = this.like01;
        setStore("id_" + id, "");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
.strage_wrapper {
  margin-bottom: 0.3rem;
  background: #f0f1f5;
  .content_wrapper {
    padding: 0.3rem 0.3rem 0.1rem;
    background: #fff;
    @include borderRadius(0.1rem);
    .strage_content {
      margin-bottom: 0.26rem;
      .title {
        @include sc(0.32rem, #333);
        font-weight: bold;
      }

      .strage_detail {
        @include sc(0.28rem, #666);
        line-height: 0.36rem;
        margin: 0.3rem 0;
      }
    }
  }
  .strage_bottom {
    padding: 0.1rem 0;
    ul {
      display: flex;
      li {
        background: rgba(246, 247, 251, 1);
        @include borderRadius(0.06rem);
        @include sc(0.24rem, #0a95ff);
        text-align: center;
        padding: 0.08rem 0.2rem;
        margin-right: 0.1rem;
        margin-bottom: 0;
      }
      li.red {
        color: #fb605a;
      }
      li.green {
        color: #51b64c;
      }
    }
  }
  .strage_info {
    text-align: right;
    @include sc(0.22rem, #999);
  }
}
.analyst_part {
  text-align: center;
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  .analyst_info {
    img {
      @include wh(1.62rem, 1.66rem);
    }
    .name {
      @include sc(0.32rem, #485266);
    }
    .time {
      @include sc(0.22rem, #666);
    }
  }
  .analyst_guide {
    .guide_title {
      @include sc(0.28rem, #333);
      margin: 0.6rem 0;
    }
    .guide_content {
      padding: 0 0.3rem;
      text-align: justify;
      @include sc(0.28rem, #333);
      line-height: 0.42rem;
    }
  }
  .like {
    @include wh(1.2rem, 1.2rem);
    background: #0a95ff;
    font-size: 0;
    border-radius: 50%;
    text-align: center;
    margin: 0.5rem auto 0.3rem;
    padding-top: 0.25rem;
    span {
      @include sc(0.24rem, #fff);
    }
    img {
      width: 0.28rem;
      margin-bottom: 0.1rem;
    }
  }
}
.trade_btn {
  line-height: 0.9rem;
  background: #0a95ff;
  text-align: center;
  @include sc(0.32rem, #fff);
  border-radius: 0.06rem;
  width: 90%;
  margin: 0.4rem auto 0;
}
.like_detail {
  position: relative;
}
</style>
